import { Injectable } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import { QuestionBase } from './question-base';

@Injectable()
export class QuestionControlService {
  toFormGroup(questions: QuestionBase<string>[]) {
    const group: any = {};

    questions.forEach((question) => {
      if (question.controlType === 'dropdowncheckbox') {
        group[question.key] = question.required
          ? new FormControl(
              question.value != null ? question.value : [],
              Validators.required
            )
          : new FormControl(question.value != null ? question.value : []);
      } else {
        group[question.key] = question.required
          ? question.isImage
            ? new FormControl(question.value || '')
            : new FormControl(
                question.value != null ? question.value : '',
                Validators.required
              )
          : new FormControl(question.value != null ? question.value : '');
      }
    });
    return new FormGroup(group);
  }
}

/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
*/
